'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('auditMandateEditModule')

.factory('auditMandateService', ['$http', function ($http) {
    var baseUrl = environment.apiUrl + '/Pilot/api/AuditMandate';

    var service = {};

    function returnData(response) {
        return response.data;
    }

    // Audit Mandate
    service.getAuditMandate = function (auditMandateId) {
        return $http
            .get(baseUrl + '/' + auditMandateId)
            .then(function (response) { return response.data; });
    };

    service.getAuditMandateByGovernanceProcessID = function (povernanceProcessId) {
        return $http
            .get(baseUrl + '/ByGovernanceProcess/' + povernanceProcessId)
            .then(function (response) { return response.data; });
    };

    service.createAuditMandate = function (auditMandate) {
        var reqUrl = baseUrl;

        return $http
            .post(reqUrl, { AuditMandate: auditMandate })
            .then(function (response) { return response.data; });
    };

    service.updateAuditMandate = function (auditMandate) {
        var reqUrl = baseUrl;
        if (!_.isUndefined(auditMandate.GovernanceProcessID)) reqUrl += '/' + auditMandate.GovernanceProcessID;

        return $http
            .put(reqUrl, { AuditMandate: auditMandate })
            .then(function (response) { return response.data; });
    };

    // Related Controls
    service.getRelatedControls = function (auditMandateId) {
        return $http
            .get(baseUrl + '/' + auditMandateId + '/Control')
            .then(function (response) { return response.data; });
    };

    service.addControlToAuditMandate = function (auditMandateId, controlId) {
        return $http
            .post(baseUrl + '/' + auditMandateId + '/Control/' + controlId)
            .then(function (response) { return response.data; });
    };
    service.removeControlFromAuditMandate = function (auditMandateId, controlId) {
        return $http
            .delete(baseUrl + '/' + auditMandateId + '/Control/' + controlId)
            .then(function (response) { return response.data; });
    };

    // Lookup Attributes
    service.getLookupAttributes = function () {
        return $http
            .get(environment.apiUrl + '/Pilot/api/LookupAttribute/Value/For/AuditMandate', { cache: true })
            .then(returnData);
    };

    return service;
}]);
